import React from 'react'
import { connect } from 'react-redux'

import * as actionCreators from '../../../store/actions'
import { mapStateToProps } from '../../../utils'

const classNames = require('classnames')

export class EditButton extends React.Component {
  handleEditClicked = () => {
    const { handleEdit, row } = this.props
    handleEdit(row)
  }

  render() {
    return (
      <div
        className={classNames('edit-icon theme-svg')}
        style={{
          backgroundSize: '20px',
          height: '20px',
          width: '20px',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
        label="edit"
        role="button"
        tabIndex={0}
        onClick={this.handleEditClicked}
        onKeyPress={this.handleEditClicked}
      />
    )
  }
}

export default connect(mapStateToProps, actionCreators)(EditButton)
